import { Component, Output, HostListener, EventEmitter, signal, AfterViewInit, inject, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { ConfigService } from '../../app-config.service';
import { CommonHttpService } from '../../shared/services/common-http.service';
import { CommonService, SpinnerService } from '../../shared/services';
import { toObservable } from '@angular/core/rxjs-interop';
import { find, map } from 'rxjs';
import { Tourservice } from '../../shared/services/tourservice';

interface City {
  name: string;
  code: string;
}

@Component({
  selector: 'bi-landing',
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
  standalone: false
})
export class LandingComponent implements OnInit, AfterViewInit {
  showPopup = signal(false);
  showPopup2 = signal(false);
  private tour = inject(Tourservice); //Take a Tour
  onScroll() {
    throw new Error('Method not implemented.');
  }
  /** `true` when `currentBIUser.ceipal_bi_upgraded == 1`; set only via `syncCeipalBiUserState` (not from template). */
  isCeipalBiUpgraded = false;
  /** `true` when `currentBIUser.hide_back_to_old_bi == 1`; hides Back to Classic BI button. */
  hideBackToOldBI = false;
  visible: boolean = false;//create report
  visible1: boolean = false;//reportt security settings
  visible2: boolean = false;//Schedule Report Automation 
  visible7: boolean = false;//Save Report for Mobile
  visible8: boolean = false;
  visible9: boolean = false;
  visible10: boolean = false;
  cities: any[] | undefined;
  selectedCities!: any[];
  checked1: boolean = true;
  groupedFilteredItems: any[] = [];
  selectedCity: City | undefined;
  @Output() navigateToDetails = new EventEmitter<void>();
  activeSection = signal<any>(0);
  sections: any = signal([]);
  activeSavedReports = signal([]);
  favoriteReportsList = signal([]);
  recentReportsList = signal([]);
  sectionsLength!: number;
  selectedTab: string = 'company-reports';
  products!: any[];//drag and drop order lists
  tabs: any = [
    { title: 'Company Reports', value: 'company-reports', 'icon': 'assets/images/tag-icon.svg', Id: "tour-all-vendors", },
    { title: 'Reports Library', value: 'reports-library', 'icon': 'assets/images/reportsLibrary-icon.svg', Id: "Add-data", },
    { title: 'Scheduled Reports', value: 'scheduled-reports', 'icon': 'assets/images/scheduledReports-icon.svg', Id: "actions", }
  ];
  leftNavMinHeight: string = '';
  constructor(private _commonHttpService: CommonHttpService,
    private _spinnerService: SpinnerService,
    private _commonService: CommonService,
    private _configService: ConfigService
  ) { }
  ngOnInit() {
    this.syncCeipalBiUserState();
    /* Take a Tour start*/
    /*  this.tour.registerSteps([
     { el: '#tour-all-vendors', t: 'Vendor Activities', d: 'A consolidated view of all Vendor-related workflows. Use this section to manage and review high-volume activity logs.' },
     { el: '#Add-data', t: 'Settings & Add Vender', d: 'Manage your account settings and register new Vendor to begin tracking their activities.' },
     { el: '#actions', t: 'Notes & Vendor Contact', d: 'Track ongoing conversations and manage your Vendor directory. A central spot for all your internal notes and communication logs.' },
     { el: '#dropDownL', t: 'Table Pagination', d: 'Use these controls to navigate through your list of vendors or change the number of rows displayed.' },
     { el: '#createReport', t: 'Table Pagination', d: 'Use these controls to navigate through your list of vendors or change the number of rows displayed.' }
   ]); */
    /* End Take a Tour */

    // Load the last selected tab from localStorage, fallback to 'company-reports'
    this.selectedTab = this.getLastSelectedTab();
    this.getReportsList(this.selectedTab);
    this.getFavouriteAndRecentReportsList();
    this.updateMinHeight();
  }
  close() {
    this.showPopup.set(false);
    this.showPopup2.set(false);
    sessionStorage.setItem('landing_popup_dismissed', 'true');
  }

  /** Reads localStorage and updates `showPopup` / `isCeipalBiUpgraded` / `hideBackToOldBI`. Do not call from template (signal writes inside computed). */
  syncCeipalBiUserState() {
    const currentBIUser = JSON.parse(localStorage.getItem('currentBIUser') || '{}');
    const ceipalBiUpgraded = currentBIUser.ceipal_bi_upgraded;
    this.isCeipalBiUpgraded = ceipalBiUpgraded == 1;
    this.hideBackToOldBI = currentBIUser.hide_back_to_old_bi == 1;
    const alreadyDismissed = sessionStorage.getItem('landing_popup_dismissed') === 'true';
    if (ceipalBiUpgraded || alreadyDismissed) {
      this.showPopup.set(false);
    } else {
      this.showPopup.set(true);
    }
  }
  setDefaultBtn() {
    this.showPopup2.set(true);
  }
  startTakeTour() {
    // 1. Register the steps
    this.tour.registerSteps([
      {
        el: '#tour-all-vendors',
        t: 'Company Reports',
        d: "Your personalized reporting hub. Reports you've selected from the Reports Library live here. Organized, accessible, and ready to run whenever you need them."
      },
      {
        el: '#Add-data',
        t: 'Reports Library',
        d: 'Explore the full catalog of reports available across your platform. Browse, preview, and add any report to your Company Reports tab with a single click. Tailored to your business needs'
      },
      {
        el: '#actions',
        t: 'Scheduled Reports',
        d: "Never pull a report manually again. View and manage all your scheduled reports here. Track what's running, how often, and where the results are being delivered"
      },
      {
        el: '#dropDownL',
        t: 'Quick Actions at Your Fingertips',
        d: "Click the ⋮ menu on any report to instantly share it with your team, schedule automated delivery, or remove it from your view. All without leaving the page"
      },
      {
        el: '#createReport',
        t: 'Create Your Own Report', // Fixed duplicate title
        d: "Build a custom report from scratch. Choose your data points, apply filters, and visualize it the way that works best for you. Your report saves directly to your Company Reports tab, ready to share or schedule anytime"
      }
    ]);

    // 2. Actually trigger the start of the tour
    this.tour.startTour();
    this.close()
  }
  /**
   * This method is used to get reports list
   * @param category 
   * @author chari on 05/28/2025
   */
  getReportsList(category: string = '') {
    this._spinnerService.withSpinner(
      this._commonHttpService.getReportsList(category),
      'Loading reports...'
    ).subscribe({
      next: (res: any) => {
        if (res.status === 1) {
          this.sectionsLength = res?.data?.modules?.length;
          console.log('res?.data?.modules', res?.data?.modules);
          this.sections.set(res?.data?.modules);
          if (this.sectionsLength)
            this.activeSection.set(res?.data?.modules[0]?.id);
        }
      },
      error: (error) => {
        console.error('Error fetching reports list:', error);
      }
    });
  }

  /**
   * This method is used to get favourite reports list
   * @author chari on 05/29/2025
   */
  getFavouriteAndRecentReportsList() {
    this._spinnerService.withSpinner(
      this._commonHttpService.getFavoriteReportsList(),
      'Loading favorite reports...'
    ).subscribe({
      next: (res: any) => {
        if (res.status === 1) {
          this.favoriteReportsList.set(res?.data?.favouriteReports);
          this.recentReportsList.set(res?.data?.reportLogs);
        }
      },
      error: (error) => {
        console.error('Error fetching favorite reports:', error);
      }
    });
  }

  goToDetails(event: Event) {
    event.preventDefault(); // ⛔ Prevent page reload
    this.navigateToDetails.emit(); // ✅ Trigger navigation
  }
  private platformId = inject(PLATFORM_ID);
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            //this.activeSection.set(entry.target.id);
          }
        });
      }, {
        rootMargin: '-100px 0px -90% 0px',
        threshold: 0
      });

      document.querySelectorAll('.content-section').forEach((section) => {
        observer.observe(section);
      });
    }
  }

  /**
   * this method is used to listen the module click
   * @param section 
   * @author chari on 05/28/2025
   */
  onSectionClick(section: any) {
    const el = document.getElementById(section.id);
    if (el) {
      this.activeSection.set(section.id);
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Convert signal to observable and check if array is empty
  isSavedReportsEmpty$ = toObservable(this.activeSavedReports).pipe(
    map(savedReports => savedReports.length === 0)
  );

  /**
   * This function is used to hold the recent tab change value
   * @param newTabValue 
   * @author chari on 05/28/2025
   */
  onTabChange(newTabValue: any) {
    this.selectedTab = newTabValue;
    this.saveLastSelectedTab(this.selectedTab);
    this.getReportsList(this.selectedTab);
    console.log('newTabValue', this.selectedTab);
    //this._commonService.showScheduleReport();
  }

  /**
   * this method is used to update the favourites list data 
   * @param item 
   * @param type 
   * @author chari on 06/05/2025
   */
  updateFavourites(item: any, type = 0) {
    if (type !== 1 && item.isFavourite == 1) {
      this.getFavouriteAndRecentReportsList();
      return;
    }

    let data: any = this.favoriteReportsList();
    let recentReportData: any = this.recentReportsList();
    if (type == 1) { //from favourites component
      data = data.filter((x: any) => (x.reportId != item.reportId && x.reportFrom == item.reportFrom));
      let sectionsData = this.sections()[(this.activeSection() - 1)];
      sectionsData = sectionsData.savedReports.map((report: any) => {
        if (report.id == item.reportId && report.reportFrom == item.reportFrom) {
          report = Object.assign(report, { isFavourite: 0 });
        }
        return report;
      });
      recentReportData = recentReportData.map((x: any) => {
        if (x.reportId == item.reportId && x.reportFrom == item.reportFrom)
          x.isFavourite = 0;
        return x;
      });
    } else if (type == 2) { //from recent reports landing screen
      data = data.filter((x: any) => (x.reportId != item.reportId && x.reportFrom == item.reportFrom));
      if (item.isFavourite == 1) {
        console.log('its called');
        data.push({
          "id": (data.length + 1),
          //"userId": data[data.length - 1].userId,
          "reportId": item.reportId,
          "savedReportId": item.reportId,
          "reportFrom": item.reportFrom,
          "isFavourite": item.isFavourite,
          "reportName": item.reportName,
          "reportDesc": item.reportDesc,
          "moduleId": item.moduleId
        });
        recentReportData = recentReportData.map((x: any) => {
          if (x.reportId == item.reportId && x.reportFrom == item.reportFrom)
            x.isFavourite = 1;
          return x;
        });
        let sectionsData = this.sections()[(this.activeSection() - 1)];
        sectionsData = sectionsData.savedReports.map((report: any) => {
          if (report.id == item.reportId && report.reportFrom == item.reportFrom) {
            report = Object.assign(report, { isFavourite: 1 });
          }
          return report;
        });
      } else {
        recentReportData = recentReportData.map((x: any) => {
          if (x.reportId == item.reportId && x.reportFrom == item.reportFrom)
            x.isFavourite = 0;
          return x;
        });
        let sectionsData = this.sections()[(this.activeSection() - 1)];
        sectionsData = sectionsData.savedReports.map((report: any) => {
          if (report.id == item.reportId && report.reportFrom == item.reportFrom) {
            report = Object.assign(report, { isFavourite: 0 });
          }
          return report;
        });
      }
    } else { //from reports landing screen
      if (this.selectedTab == 'scheduled-reports')
        item.id = item.reportId;
      console.log('item.reportFrom', item.reportFrom);
      console.log('x.reportId', item.id);
      console.log('data', data);
      data = data.filter((x: any) => ((x.reportId !== item.id) && (x.reportFrom == item.reportFrom)));
      console.log('data1', data);
      if (item.isFavourite == 1) {
        console.log('its called');
        data.push({
          "id": (data.length + 1),
          //"userId": data[data.length - 1].userId,
          "reportId": item.id,
          "savedReportId": item.id,
          "reportFrom": item.reportFrom,
          "isFavourite": item.isFavourite,
          "reportName": item.reportName,
          "reportDesc": item.reportDesc,
          "moduleId": item.moduleId
        });
        recentReportData = recentReportData.map((x: any) => {
          if (x.reportId == item.id && x.reportFrom == item.reportFrom)
            x.isFavourite = 1;
          return x;
        });
      } else {
        recentReportData = recentReportData.map((x: any) => {
          if (x.reportId == item.id && x.reportFrom == item.reportFrom)
            x.isFavourite = 0;
          return x;
        });
      }
    }
    console.log(item);
    console.log('chari', type);
    console.log('chari', data, recentReportData);
    this.favoriteReportsList.set(data);
  }

  /**
   * this method is used to update companies list data 
   * @param item 
   * @author chari on 06/05/2025
   */
  updateUntag({ item, sectionId }: { item: any, sectionId: any }) {
    let sectionsData = (this.sections().find((x: any) => x.id == sectionId))?.savedReports;
    sectionsData = sectionsData.filter((report: any) => report.id != item.id);
    let allSections = this.sections().map((section: any, index: number) => {
      if (section.id == sectionId) {
        section = Object.assign(section, { savedReports: sectionsData });
      }
      return section;
    });
  }

  /**
   * this method is used to update the list based on the report delete item
   * @param data 
   * @author chari on 06/05/2025
   */
  deleteReport({ reportItem, sectionId }: { reportItem: any, sectionId: any }) {
    // Refresh favorite and recent reports list after deletion
    this.getFavouriteAndRecentReportsList();
    let sectionsData = (this.sections().find((x: any) => x.id == sectionId))?.savedReports;
    sectionsData = sectionsData.filter((report: any) => report.id != reportItem.id);
    let allSections = this.sections().map((section: any, index: number) => {
      if (section.id == sectionId) {
        section = Object.assign(section, { savedReports: sectionsData });
      }
      return section;
    });
  }

  /**
   * Handle tag report action from report item component
   * @param reportItem - The report item data
   */
  handleTagReportAction(reportItem: any) {
    console.log('Tag report action received:', reportItem);
    // You can add logic here to call report-details or perform other actions
    // For example: this.navigateToReportDetails(reportItem);
  }

  /**
   * Handle share report action from report item component
   * @param reportItem - The report item data
   */
  handleShareReportAction(reportItem: any) {
    console.log('Share report action received:', reportItem);
    // You can add logic here to call report-details or perform other actions
    // For example: this.navigateToReportDetails(reportItem);
  }

  /**
   * Handle schedule report action from report item component
   * @param reportItem - The report item data
   */
  handleScheduleReportAction(reportItem: any) {
    console.log('Schedule report action received:', reportItem);
    // You can add logic here to call report-details or perform other actions
    // For example: this.navigateToReportDetails(reportItem);
  }

  showGenerateReportForm() {
    this._commonService.showGenerateReportForm({}, true);
  }







  @HostListener('window:resize')
  onResize() {
    this.updateMinHeight();
  }

  updateMinHeight() {
    const screenHeight = window.innerHeight;
    this.leftNavMinHeight = `${screenHeight - 151}px`;
  }

  /**
   * Save the selected tab to localStorage
   * @param tabValue 
   * @author Prachethan | 22-08-2025  
   */
  private saveLastSelectedTab(tabValue: string): void {
    try {
      localStorage.setItem('landing_last_tab', tabValue);
    } catch (error) {
      console.warn('Could not save tab to localStorage:', error);
    }
  }

  /**
   * Get the last selected tab from localStorage
   * @returns string - the last selected tab or 'company-reports' as default
   * @author Prachethan | 22-08-2025  
   */
  private getLastSelectedTab(): string {
    try {
      const savedTab = localStorage.getItem('landing_last_tab');
      // Validate that the saved tab exists in our tabs array
      const isValidTab = this.tabs.some((tab: any) => tab.value === savedTab);
      return isValidTab ? savedTab || 'company-reports' : 'company-reports';
    } catch (error) {
      console.warn('Could not read tab from localStorage:', error);
      return 'company-reports';
    }
  }

  changeDefaultSetting() {
    //console.log('changeDefaultSetting');
    //call api to change default setting
    this._commonHttpService.changeDefaultSetting().subscribe({
      next: (res: any) => {
        //console.log('res', res);
        const currentBIUser = JSON.parse(localStorage.getItem('currentBIUser') || '{}');
        localStorage.setItem('currentBIUser', JSON.stringify({ ...currentBIUser, ceipal_bi_upgraded: 1 }));
        this.syncCeipalBiUserState();
      },
      error: (error) => {
        console.error('Error changing default setting:', error);
      }
    });
  }

  backtoOldBI() {
    this._commonHttpService.getFormDataForClassicBI().subscribe({
      next: (res: any) => {
        if (res?.status !== 1) {
          console.error('get-form-data-for-classic-bi failed:', res?.message ?? res);
          return;
        }
        const fields = res.data;
        if (!fields || typeof fields !== 'object' || Array.isArray(fields)) {
          console.error('Invalid Classic BI form payload', res);
          return;
        }
        const classicUrl = this._configService.get('platform')?.classicBiUrl as string | undefined;
        if (!classicUrl) {
          console.error('classicBiUrl is not set in platform config');
          return;
        }
        this.submitPostFormNewWindow(classicUrl+'ReportDetails/reportsLogin', fields as Record<string, unknown>);
      },
      error: (error) => {
        console.error('Error getting form data for Classic BI:', error);
      },
    });
  }

  /** POST hidden fields to `action` and show the response in a new browser tab. */
  private submitPostFormNewWindow(action: string, fields: Record<string, unknown>) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = action;
    form.target = '_blank';
    form.acceptCharset = 'UTF-8';
    form.style.display = 'none';
    //console.log('form', form);return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'reports_login_data';
    //fields['th_url'] = this._configService.get('platform')?.thDomain as string;
    fields['th_reports_url'] = this._configService.get('platform')?.thDomain as string+'/Reports/GeneralReport';
    fields['user_business_unit_details'] = [];
    console.log('fields', fields);
    input.value = JSON.stringify(fields);
    form.appendChild(input);
    //console.log('form', form);return;
    document.body.appendChild(form);
    form.submit();
  }
}
